import { Suspense, useContext, useEffect, useRef, useState } from 'react';
import TableView from '../components/TableView';
import './DayPartingView.scss';
import styles from './DayPartingView.scss.json';
import { DayPicker } from 'react-day-picker';
import { BrandAccountSelector } from '../components/RefreshQuoraData';
import { useSuspense } from '../utils';
import { BrandAccount } from 'titan-ads/lib/shapes/TitanShapes';
import { Server } from 'lincd-server-utils/lib/utils/Server';
import { packageName } from '../package';
import { DashboardContext } from '../contexts/Dashboard';
import {formatCurrency,formatPercentage} from '../utils/data';
import { QuoraAccount } from 'titan-ads/lib/shapes/QuoraAccount';
import { useScreenshot } from 'use-react-screenshot';
import dayjs from 'dayjs';
import { Spinner } from '../components/Spinner';

const DayPartingView = () => {
    const initialBrands = useSuspense(BrandAccount.loadAll());
    const [brands] = useState<{ read(): any }>(initialBrands);
    const [selectedDate, setSelectedDate] = useState<string>(dayjs().format('YYYY-MM-DD'));
    const [showDayPicker, setShowDayPicker] = useState<boolean>(false);
    const [source, setSource] = useState<any[]>([]);
    const [bestPerformingAds, setBestPerformingAds] = useState<any[]>([]);
    const { curAccount } = useContext(DashboardContext);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [isBestPerformingAdsLoading, setIsBestPerformingAdsLoading] = useState<boolean>(false);
    const [campaignBid, setCampaignBid] = useState<any>('');
    const [quoraAccounts, setQuoraAccounts] = useState<QuoraAccount[]>([]);
    const [selectedQuoraAccount, setSelectedQuoraAccount] = useState<QuoraAccount | null>(null);
    const ref = useRef<HTMLDivElement>(null);
    const [image, takeScreenshot] = useScreenshot();
    const [checked, setChecked] = useState<string>('brandAccount');
    const clientQuoraAccount = Array.from(
        new Set(quoraAccounts.filter(
            (account) => !account.name.includes('Semantu') && !account.name.includes('LINCD'))))
            .filter((acc, index, item) => index === item.findIndex((t) => t.quoraId === acc.quoraId));

    const handleCheckbox = (e: any) => {
        const value = e.target.value;
        setChecked(value);
    }

    const handleSelectedDate = (date: Date) => {
      if (!date) return;
      setSelectedDate(dayjs(date).format('YYYY-MM-DD'));
    }

    const getDailyAdsData = async () => {
        try {
            setLoading(true);
            // send params to backend date and what constraint for getting the report (brand or quora account)
            const adData = await Server.call(packageName, 'getDayPartingData', selectedDate, checked === 'brandAccount' ? curAccount : selectedQuoraAccount);
            if(adData) setSource(adData.data);
            // alert(`No Ad Matched for Date ${formatDate(selected)} for account ${curAccount.name} - ${adData}`)
            setLoading(false);
        } catch (e) {
            console.log('Error getting daily ad data for report');
            return [];
        }
    };

    const getBestPerformingAds = async () => {
      try {
          setIsBestPerformingAdsLoading(true);
          // send params to backend date and what constraint for getting the report (brand or quora account)
          const adData = await Server.call(packageName, 'getBestPerformingAds', selectedDate, checked === 'brandAccount' ? curAccount : selectedQuoraAccount);
          if(adData) setBestPerformingAds(adData.data);
          setIsBestPerformingAdsLoading(false);
      } catch (e) {
          console.log('Error getting ad data for report');
          return [];
      }
  };

    function formatAdDataForTable(adDataByDay, advertiserData = []) {
        const formattedData = [];
        adDataByDay.forEach((dataEntry, index) => {
            Object.keys(dataEntry).forEach(key => {
                // const advertiserValue =
                //     advertiserData[index]?.[key] !== undefined
                //         ? advertiserData[index][key]
                //         : '';
    
                const shouldFormatAsPlainNumber = [
                    'ROAS',
                    'Traffic Source (Quora) Clicks',
                    'Tracker (TCG or Voluum?) Clicks',
                    'Advertiser Sales',
                    'Total Ads',
                    'Active Ads (Running)',
                    'Ads w/ Clicks',
                    'Ads w/ Conversions',
                    'Range # of Ads Engaged From Last Week (Min/Max)',
                    'Number of Test Ads with Delivery',
                    'Clicks from Test Ads',
                    'Sales from Test Ads',
                    'Number of Test Ads with average CTR (1.6–2%)',
                    'Number of Test Ads with above average CTR (>2%)'
                ].includes(key);

                const colorCoded = [
                    'Daily P/L',
                    'Campaign',
                    'Todays P/L Peak',
                    'Delta From P/L Peak',
                    'Gross Margin'
                ];
    
                const shouldFormatAsPercentage = [
                  'Gross Margin', 
                  '% of Ads w/ Clicks', 
                  '% of Ads w/ Conversions',
                  '% Clicks from Test Ads',
                  'Test Ads CVR'  
                ].includes(key);
    
                formattedData.push({
                    metric: key,
                    quoraPL: key === 'Campaign Bid(s)'
                        ? <input
                            type="text"
                            value={campaignBid}
                            onChange={(e) => setCampaignBid(e.target.value)}
                            className={styles.campaignBids}
                          />
                        : key === 'Campaign' && colorCoded.includes(key)
                        ? <p
                            className={
                              dataEntry[key] === 'ON'
                                ? styles.green
                                : styles.red
                            }
                          >
                            <span>{dataEntry[key]}</span>
                          </p>
                        : typeof dataEntry[key] === 'number'
                            ? colorCoded.includes(key)
                                ? <p className={
                                    dataEntry[key] === 0
                                      ? ''
                                      : dataEntry[key] < 0
                                        ? styles.red
                                        : styles.green
                                  }>
                                    <span>
                                      {shouldFormatAsPercentage
                                          ? formatPercentage(dataEntry[key])
                                          : shouldFormatAsPlainNumber
                                              ? dataEntry[key].toLocaleString()
                                              : formatCurrency(dataEntry[key])
                                      }
                                    </span>
                                  </p>
                                : shouldFormatAsPercentage
                                    ? formatPercentage(dataEntry[key])
                                    : shouldFormatAsPlainNumber
                                        ? dataEntry[key].toLocaleString()
                                        : formatCurrency(dataEntry[key])
                            : dataEntry[key],
                });
            });
        });
        return formattedData;
    }
    
    const formatDate = (date: Date) => {
      return date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2,'0') + '-' + date.getDate().toString().padStart(2, '0');
        // return date.toLocaleDateString('en-US', { year: '2-digit', month: '2-digit', day: '2-digit' });
    }

    useEffect(() => {
      if (selectedDate && (curAccount || selectedQuoraAccount)) {
          getDailyAdsData();
          getBestPerformingAds();
      }
    },[selectedDate, curAccount, selectedQuoraAccount, checked]);
    useEffect(() => {

        (async () => {
            const quoraAccount = await QuoraAccount.loadAll();
            quoraAccount?.forEach((account) => {
                setQuoraAccounts((prev) => [...prev, account]);
            });
        })();
        
        if (location.pathname.includes('/view/daily-ad-report')) {
            document.querySelectorAll('.titan_DefaultLayout_main').forEach((element) => {
                (element as HTMLElement).style.maxWidth = 'none';
            });
        }
    }, [location.pathname, selectedDate]);

    return (
      <>
        <div className={styles.dailyAdContainer}>
          <h3>Generate Report - Daily Ad View</h3>
          <div className={styles.accountSelector}>
            <h4>Report specificity:</h4>
            <div className={styles.inputReport}>
              <div className={styles.checkbox}>
                <p>Brand Account</p>
                <input type="checkbox" value={'brandAccount'} checked={checked === 'brandAccount'} onChange={handleCheckbox} />
              </div>
              <div className={styles.checkbox}>
                <p>Quora Account</p>
                <input type="checkbox" value={'quoraAccount'} checked={checked === 'quoraAccount'} onChange={handleCheckbox} />
              </div>
            </div>
            {checked === 'brandAccount' && (<>
              <h4>Brand Account:</h4>
              <Suspense fallback={<BrandAccountSelector.Loading />}>
                <BrandAccountSelector qAccounts={brands} showLabel={false} />
              </Suspense>
            </>)}
            {/* select quora Account */}
            {checked === 'quoraAccount' && (<>
              <div className={styles.quoraAccountSelector}>
                <h4>Quora Account:</h4>
                <select
                  disabled={checked === 'quoraAccount' ? false : true}
                  onChange={(e) => {
                    const selectedAccount = QuoraAccount.getFromURI(e.target.value);
                    setSelectedQuoraAccount(selectedAccount);
                  }}
                  value={selectedQuoraAccount?.uri}
                >
                  {!clientQuoraAccount && (
                    <option>Choose an account</option>
                  )}
                  {clientQuoraAccount?.map((acc: QuoraAccount) => {
                    return (
                      <option data-key={acc.uri} key={acc.uri} value={acc.uri}>
                        {acc.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </>)}
            <div className={styles.inputDatePicker}>
              <h4>Date Selector:</h4>
              {!showDayPicker ? (
                <input
                  type="text"
                  readOnly
                  value={selectedDate ? selectedDate : 'Select Day'}
                  onClick={() => setShowDayPicker(!showDayPicker)}
                />
              ) : (
                <div className={styles.calendarPicker}>
                  <DayPicker
                    mode="single"
                    disabled={{ after: new Date() }}
                    onSelect={(selected) => {
                        handleSelectedDate(selected);
                        setShowDayPicker(!showDayPicker);
                    }}
                  />
                </div>
              )}
            </div>

            <button className={styles.screenShotbtn} disabled={source.length === 0} onClick={() => {
              takeScreenshot(ref.current).then((image) => {
                const link = document.createElement('a');
                link.href = image;
                link.download = `Daily_AD_Report_${selectedDate}.png`;
                link.click();
              });
            }}>Take screenshot
            </button>
          </div>
          <TableView 
            ref={ref}
            data={formatAdDataForTable(source)}
            reportType='daypartingview'
            isLoading={isLoading}
            account={checked === 'brandAccount' ? curAccount?.name : selectedQuoraAccount?.name} 
            selectedDate={selectedDate as string}
          />
        </div>
        <div className={styles.dailyAdContainer}>

          { isBestPerformingAdsLoading ? (
            <h4>Loading Best Performing Ads...</h4>
          ) : <><h2>Best performing ads on {selectedDate}</h2>{bestPerformingAds.map((ad, index) => {
              return (
                <>
                  <h3>{ad.Type}</h3>
                  <table className={styles.tableReport}>
                  <thead>
                    <tr>
                      <th>Property Name</th>
                      <th>Value</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ad.length === 0 ? (
                      <tr>
                        <td colSpan={6} style={{ textAlign: 'center' }}>
                          No data available
                        </td>
                      </tr>
                    ) : (
                      Object.entries(ad).filter(([key]) => key !== "Type").map(([key, value]) => (
                        <tr>
                          <td>{key}</td>
                          <td> {value === null || value === undefined
                              ? "-"
                              : typeof value === "object"
                              ? JSON.stringify(value)
                              : String(value)}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
                </>
                
              )
            })
          }</>}
         
        </div>
      </>
    );
};

export default DayPartingView;
